type ValidHost = 'development' | 'test' | 'acceptance' | 'production';

const hostMap: Record<string, ValidHost> = {
  'test01.taf.nl': 'test',
  'test02.taf.nl': 'test',
  'test03.taf.nl': 'test',
  'test05.taf.nl': 'test',
  'test06.taf.nl': 'test',
  'acceptatie01.taf.nl': 'acceptance',
  'gezondheidsverklaring.taf.nl': 'production',
};

type Host = typeof hostMap[keyof typeof hostMap];

export const getSentryEnvironment = (): Host => {
  const host = window.location.hostname;

  return hostMap[host] || 'development';
};
